import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

const Header = ({ showGuide = true, hideNavButtons = false }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isAboutPage = location.pathname === '/about';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-md border-b border-gray-800/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-32">
          {/* Logo - enlarged */}
          <a href="https://www.smart-info.it/cyber-security" className="flex items-center" target="_blank" rel="noopener noreferrer">
            <img 
              src="https://customer-assets.emergentagent.com/job_web-audit-tool-7/artifacts/o8y9x9lm_Logo%20Smart%20Info%20CYBER%20Red.png" 
              alt="Smart Info Cyber Security" 
              className="h-52 w-auto"
            />
          </a>

          {/* Navigation - hidden on results page */}
          {!hideNavButtons && (
            <div className="flex items-center gap-3">
              {showGuide && !isAboutPage && (
                <Link
                  to="/about"
                  className="px-4 py-2.5 bg-gray-800 hover:bg-gray-700 text-white rounded-lg transition-all text-sm font-medium flex items-center gap-2"
                >
                  <HelpCircle className="h-4 w-4" />
                  Guida
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
